export const CHANGE_VIDEOLIST = 'video/change_video_list'
export const CHANGE_SHOWLOADING = 'video/change_showloading'
